import * as React from 'react';
import { useMemo } from 'react';
import { RichTextInput } from 'ra-input-rich-text';
import {
    BooleanField,
    BulkDeleteButton,
    BulkExportButton,
    ChipField,
    SelectColumnsButton,
    CreateButton,
    DatagridConfigurable,
    DateField,
    downloadCSV,
    EditButton,
    ExportButton,
    FilterButton,
    List,
    InfiniteList,
    NumberField,
    ReferenceArrayField,
    ReferenceManyCount,
    SearchInput,
    ShowButton,
    SimpleList,
    SingleFieldList,
    TextField,
    TextInput,
    TopToolbar,
    useTranslate,
    DeleteButton,

} from 'react-admin'; // eslint-disable-line import/no-unresolved
import ResetViewsButton from './ResetViewsButton';
import { useMediaQuery, Theme } from '@mui/material';
import { usePermissions } from 'react-admin';
import { useRedirect } from 'react-admin';
import { useNotify } from 'react-admin';
import { useCreate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';




const RanList = () => (

    <List
        sort={{ field: 'created_at', order: 'DESC' }}
        // perPage="5"
        // Totals="10"
    >
        <DatagridConfigurable rowClick="edit">
            <TextField source="id" />
            <TextField source="sName" />
            <DateField source="created_at" />
            <EditButton />
            <ShowButton />
        </DatagridConfigurable>
    </List>
);

export default RanList;